import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useCreateVersion = () => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    isSuccess,
    request,
    error,
  } = useQuery((data) => api.admin.updateVersion(data))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  useEffect(() => {
    if (isSuccess) {
      toast({
        title: 'Готово',
        description: 'Версия успешно создана',
        status: 'success'
      })
    }
  }, [isSuccess])

  return {
    createVersion: request,
    isLoading
  }
}
